// Enregistrement du service worker
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('Service Worker enregistré avec succès:', registration.scope);
          
          // Vérifier les mises à jour
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('Nouvelle version disponible');
              }
            });
          });
        })
        .catch((error) => {
          console.warn('Échec de l\'enregistrement du Service Worker:', error);
        });
    });
  }
};

// Désenregistrement du service worker (pour le développement)
export const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('Service Worker désenregistré');
      })
      .catch((error) => {
        console.error('Erreur lors du désenregistrement:', error);
      });
  }
};

// Demande de permission pour les notifications
export const requestNotificationPermission = async () => {
  if ('Notification' in window) {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  return false;
};

// Envoi d'une notification
export const sendNotification = (title, options = {}) => {
  if ('Notification' in window && Notification.permission === 'granted') {
    const defaultOptions = {
      icon: '/android-chrome-192x192.png',
      badge: '/android-chrome-192x192.png',
      vibrate: [100, 50, 100],
      ...options
    };
    
    new Notification(title, defaultOptions);
  }
};

// Vérification de la connectivité
export const checkConnectivity = () => {
  return navigator.onLine;
};

// Écouteur de changement de connectivité
export const addConnectivityListener = (callback) => {
  window.addEventListener('online', () => callback(true));
  window.addEventListener('offline', () => callback(false));
};
